import tokenStore from './token_store.js'

export function requiresCsrfToken (options) {
  return !/^(get|head|options)$/i.test(options.type) &&
    tokenStore.expectedFor(options.url) &&
    !options.firehose
}
